// src/api.js

// Mantém o /api pra todas as suas rotas (login, register, etc)
const BASE = window.location.hostname.includes('localhost')
  ? 'http://localhost:3000'
  : 'https://grandfantasiazephyr.online/api';


/**
 * Lê o JSON da resposta e lança erro se status >= 400
 * @param {Response} res
 * @returns {Promise<any>}
 */
async function checkStatus(res) {
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro na requisição');
  return data;
 }

 // wrapper que sempre puxa o token do localStorage e injeta no header
function authFetch(url, opts = {}) {
  const token = localStorage.getItem('jwt_token')
  const headers = {
    ...(opts.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  }
  return fetch(url, { mode: 'cors', ...opts, headers })
}

export async function login(mid, password, captchaResponse) {
  
  const res = await fetch(`${BASE}/login`, {
    method: 'POST',
    mode: 'cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mid, password, captchaResponse })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro no login');
  return data;
}

export async function register(mid, apelido ,email, password) {
  const res = await fetch(`${BASE}/register`, {
    method: 'POST',
    mode: 'cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mid, apelido,email, password })
  });
  const data = await res.json();
  
  if (!res.ok) throw new Error(data.error || 'Erro no registro');
  return data;
}

export async function confirmRegistration(email, code) {
  const res = await fetch(`${BASE}/confirm-registration`, {
    method: 'POST',
    mode: 'cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, code })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao confirmar registro');
  return data;
}

export async function fetchMe(token) {
  
  const res = await fetch(`${BASE}/me`, {
    headers: { 'Authorization': 'Bearer ' + token }
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar usuário');
  return data;
}

export async function fetchCharacters(token) {
  const res = await fetch(`${BASE}/characters`, {
    method: 'GET',
    mode: 'cors',
    headers: { 'Authorization': 'Bearer ' + token }
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar personagens');
  return data;
}

export async function changePassword(token, currentPassword, newPassword) {
  const res = await fetch(`${BASE}/change-password`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type':  'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify({ currentPassword, newPassword })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao trocar senha');
  return data;
}

export async function fetchMail(token) {
  const res = await fetch(`${BASE}/mail`, {
    method: 'GET',
    mode: 'cors',
    headers: { 'Authorization': 'Bearer ' + token }
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar mensagens');
  return data;
}




export async function fetchRedeemStatus(token) {
  const res = await fetch(`${BASE}/daily-check/status`, {
    method: 'GET',
    headers: { 'Authorization': 'Bearer ' + token }
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar status de resgate');
  return data;
}

export async function redeemDaily(token, itemId) {
  const res = await fetch(`${BASE}/daily-check/redeem`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify({ itemId })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro no resgate diário');
  return data;
}

export async function fetchPlayableCharacters(token) {
  const res = await fetch(`${BASE}/roleta/characters`, {
    method: 'GET',
    headers: { 'Authorization': 'Bearer ' + token }
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar saldo do usuário');
  return data;
}

export async function playRoleta(token, itemId, quantity, currency) {
  const res = await fetch(`${BASE}/roleta/play`, {
    method:  'POST',
    mode:    'cors',
    headers: {
      'Content-Type':  'application/json',
      'Authorization': 'Bearer ' + token
    },
    // não precisa de characterId agora
    body: JSON.stringify({ itemId, quantity, currency })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao jogar roleta');
  return data; // { pvalues, bonus }
}

export async function requestPasswordReset(email) {
  const res = await fetch(`${BASE}/password-reset`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao solicitar reset');
  return data;
}

export async function confirmPasswordReset(token, newPassword) {
  const res = await fetch(`${BASE}/password-reset/confirm`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, newPassword })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao confirmar reset');
  return data;
}

export async function changeEmail(token, newEmail) {
  const res = await fetch(`${BASE}/change-email`, {
    method: 'POST',
    headers: {
      'Content-Type':  'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify({ newEmail })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao alterar e-mail');
  return data;
}

export async function verifyEmail(token, email) {
  const res = await fetch(`${BASE}/verify-email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify({ email })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao verificar e-mail');
  return data;
}

// **Aqui: só mude a rota, sem mexer no BASE**
export async function createPreference(amountReal, token) {
  const res = await fetch(`${BASE}/mercadopago/preference`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      // só inclua Authorization se usar token
      ...(token && { 'Authorization': 'Bearer ' + token })
    },
    body: JSON.stringify({ amountReal })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao criar preferência');
  return data; // { preferenceId }
}


export async function notifyDiscord(amountReal, token) {
  const res = await fetch(`${BASE}/notify-discord`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify({ amountReal })
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Erro ao notificar o Discord')
  return data
}

//api de integração cmo sugestão de alquimia

export async function sendAlquimiaSuggestion(token, mid, idsMatrix, imageBase64) {
  const res = await fetch(`${BASE}/alquimia`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify({ mid, idsMatrix, imageBase64 })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao enviar sugestão de alquimia');
  return data;
}


export async function fetchRankDeaths(token) {
  const res  = await fetch(`${BASE}/rank/deaths`, {
    headers: { 'Authorization': 'Bearer ' + token }
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar rank de mortes')
  return data
}

export async function fetchRankCrystalDamage(token) {
  const res  = await fetch(`${BASE}/rank/crystal-damage`, {
    headers: { 'Authorization': 'Bearer ' + token }
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar rank de dano cristal')
  return data
}

export async function fetchRankHeal(token) {
  const res  = await fetch(`${BASE}/rank/heal`, {
    headers: { 'Authorization': 'Bearer ' + token }
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar rank de cura')
  return data
}

export async function fetchRankPlayerDamage(token) {
  const res  = await fetch(`${BASE}/rank/player-damage`, {
    headers: { 'Authorization': 'Bearer ' + token }
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar rank de dano em jogadores')
  return data
}

export async function fetchRankWins(token) {
  const res  = await fetch(`${BASE}/rank/wins`, {
    headers: { 'Authorization': 'Bearer ' + token }
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar rank de vitórias')
  return data
}

export async function fetchRankByClass(token, classId) {
  const res = await fetch(`${BASE}/rank/class/${classId}`, {
    headers: { 'Authorization': 'Bearer ' + token }
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar rank por classe');
  return data;
}


// **NOVO**: Busca somente pvalues para o Blackjack
export async function fetchBetBalance(token) {
  const res = await fetch(`${BASE}/bet/balance`, {
    headers: { 'Authorization': 'Bearer ' + token }
  });
  return checkStatus(res); // { user: { mid, pvalues } }
}

export async function settleBet(token, amount, won) {
  const res = await fetch(`${BASE}/bet/settle`, {
    method: 'POST',
    headers: {
      'Content-Type':  'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify({ amount, won })
  });
  return checkStatus(res); // { pvalues }
}

export function createGameSession(body) {
  return authFetch(`${BASE}/game-session/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  }).then(checkStatus)
}

// entra em sala existente
export function joinGameSession(sessionId, password) {
  return authFetch(`${BASE}/game-session/join`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionId, password })
  }).then(checkStatus)
}

export function actionGameSession(sessionId, action) {
  return authFetch(`${BASE}/game-session/action`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionId, action })
  }).then(checkStatus)
}

export function fetchGameSessionStatus(sessionId) {
  // este endpoint não exige Authorization no seu backend
  return fetch(`${BASE}/game-session/status?sessionId=${sessionId}`)
    .then(res => {
      if (!res.ok) return res.json().then(d => { throw new Error(d.error) })
      return res.json()
    })
}


export function restartGameSession(sessionId) {
  return authFetch(`${BASE}/game-session/restart`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionId })
  }).then(checkStatus)
}

export function leaveGameSession(sessionId) {
  return authFetch(`${BASE}/game-session/leave`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sessionId })
  }).then(checkStatus)
}



/* Rotas frontend damas multplayer */
// ** Checkers Multiplayer **
export function createCheckersSession({ isPublic, betAmount }, token) {
  return authFetch(`${BASE}/checkers-session/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer '+token },
    body: JSON.stringify({ isPublic, betAmount })
  }).then(checkStatus);
}

export function joinCheckersSession(sessionId, password, token) {
  return authFetch(`${BASE}/checkers-session/join`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer '+token },
    body: JSON.stringify({ sessionId, password })
  }).then(checkStatus);
}

export function fetchCheckersSessionStatus(sessionId) {
  return fetch(`${BASE}/checkers-session/status?sessionId=${sessionId}`)
    .then(res => res.ok ? res.json() : res.json().then(d=>{throw new Error(d.error)}));
}

export function actionCheckersSession(sessionId, from, to, token) {
  return authFetch(`${BASE}/checkers-session/action`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer '+token },
    body: JSON.stringify({ sessionId, from, to })
  }).then(checkStatus);
}

export function restartCheckersSession(sessionId, token) {
  return authFetch(`${BASE}/checkers-session/restart`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer '+token },
    body: JSON.stringify({ sessionId })
  }).then(checkStatus);
}

export function leaveCheckersSession(sessionId, token) {
  return authFetch(`${BASE}/checkers-session/leave`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer '+token },
    body: JSON.stringify({ sessionId })
  }).then(checkStatus);
}

export function pingCheckersSession(sessionId, token) {
  return authFetch(`${BASE}/checkers-session/ping`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer '+token },
    body: JSON.stringify({ sessionId })
  }).then(res => res.json());
}

// busca saldo do caça-níquel
export async function fetchSlotBalance(token) {
  const res = await fetch(`${BASE}/slot/balance`, {
    method: 'GET',
    headers: { 'Authorization': 'Bearer '+token }
  });
  return checkStatus(res); // retorna { user: { mid, pvalues, bonus } }
}

// solicita giro
export async function spinSlot(token, currency) {
  const res = await fetch(`${BASE}/slot/spin`, {
    method: 'POST',
    headers:{
      'Content-Type':'application/json',
      'Authorization':'Bearer '+token
    },
    body: JSON.stringify({ currency })
  });
  return checkStatus(res); 
}


export async function fetchScaleSpentPoints(token) {
  // usa o BASE (http://localhost:3000 em dev, ou https://…/api em prod)
  const res = await fetch(`${BASE}/scale/spent`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  if (!res.ok) throw new Error(`Erro ${res.status}`);
  return res.json(); // { spent: number }
}

// ** NOVAS ROTAS para resgate de escala **
export async function fetchScaleRescueStatus(token) {
  const res = await fetch(`${BASE}/scale/rescue-status`, {
    headers: { 'Authorization': `Bearer ${token}` }
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar resgates')
  return data      // { rescues: [1,2, ...] }
}

export async function redeemScale(token, scale) {
  const res = await fetch(`${BASE}/scale/rescue`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ scale })
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Erro ao resgatar escala')
  return data
}


export async function redeemScaleItem(token, scale, itemId, quantity) {
  const res = await fetch(`${BASE}/scale/redeem-item`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify({ scale, itemId, quantity })
  })
  const data = await res.json()
  if (!res.ok) throw new Error(data.error || 'Erro ao resgatar item')
  return data
} 

export async function fetchScaleRanking(token) {
  const res = await fetch(`${BASE}/scale/ranking`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type':  'application/json'
    }
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar ranking de gastos');
  return data;
}

/* Rotas relacionadas ao marketing place */
// busca todos os anúncios
export async function fetchSales() {
  const res = await fetch(`${BASE}/sales`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('jwt_token')}` }
  });
  return checkStatus(res);
}

// cria novo anúncio (FormData)
export async function createSale(formData) {
  const res = await fetch(`${BASE}/sales`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('jwt_token')}`
      // NÃO defina Content-Type
    },
    body: formData
  });
  return checkStatus(res);
}

export async function updateSurname(token, surname) {
  const res = await fetch(`${BASE}/update-surname`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ surname })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao atualizar apelido');
  return data;
}

export async function uploadAvatar(token, file) {
  const formData = new FormData();
  formData.append('avatar', file);
  const res = await fetch(`${BASE}/upload-avatar`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: formData
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao enviar avatar');
  return data; // { url }
}



export async function requestService(token, serviceType, data) {
  const res = await fetch(`${BASE}/service-request`, {
    method:  'POST',
    mode:    'cors',
    headers: {
      'Content-Type':  'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ serviceType, data })
  })
  const json = await res.json()
  if (!res.ok) throw new Error(json.error || 'Erro ao solicitar serviço')
  return json
}


export async function requestEmailChange(token, newEmail) {
  const res = await fetch(`${BASE}/change-email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ newEmail })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error);
  return data;
}

// confirma o e-mail (usa o token recebido por querystring)
export async function confirmEmailChange(token) {
  const res = await fetch(`${BASE}/confirm-email-change`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error);
  return data;
}



export async function fetchExtraStatus(token) {
  const res = await fetch(`${BASE}/scale/extra-status`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar status extra');
  return data; // { eligible: boolean, rank: number|null }
}

/**
 * Dispara o resgate do prêmio extra:
 * POST /scale/extra-reward → { success: true, rewardedItems: [ { id, quantity } ] }
 */
export async function redeemExtraReward(token) {
  const res = await fetch(`${BASE}/scale/extra-reward`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao resgatar prêmio extra');
  return data; // { success: true, rewardedItems: [...] }
}


export async function redeemExtraSurprise(token, surpriseId) {
  const res = await fetch(`${BASE}/scale/extra-surprise`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ surpriseId })
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro ao resgatar Surpresa GM (prêmio extra)');
  return data; // { success: true, insertedSurprise: { id, quantity }, rank }
}